import { useEffect } from 'react';
import {useSelector} from 'react-redux';
import {RootState} from '../store/store';
import {useResourceCreationLock} from '../components/TrialLock';

/**
 * Opens a resource's existing creation modal when it is reached through the
 * deployment launcher. The URL flag is consumed immediately so a refresh does
 * not surprise a user by reopening a form they already dismissed.
 */
const useAutoOpenCreateModal = (open: (value: boolean) => void, lockedOnLegacyTrial = true) => {
    const forecast = useSelector((state: RootState) => state.billingForecast.forecast);
    const blocked = useResourceCreationLock(lockedOnLegacyTrial, true);
    useEffect(() => {
        if (!forecast) return;
        const search = new URLSearchParams(window.location.search);
        if (search.get('create') !== '1') return;

        if (!blocked) open(true);
        search.delete('create');
        const nextUrl = `${window.location.pathname}${search.size ? `?${search.toString()}` : ''}${window.location.hash}`;
        window.history.replaceState(window.history.state, '', nextUrl);
    }, [open, blocked, forecast]);
    return !forecast || !!blocked;
};

export default useAutoOpenCreateModal;
